<template lang="pug">
.section-details
  .row(v-if="section")
    .col-sm-12
      .panel.panel-default
        .panel-heading
          .panel-title Section Details
          .text-center.loading(v-if="loading")
            i.fa.fa-spinner.fa-pulse.fa-spin
        .panel-body
          .container-fluid
            .row
              label.col-sm-2.control-label Comment
              .col-sm-4
                span(v-if="section.comment") {{section.comment}}
                em.text-muted(v-else) No comment
              label.col-sm-2.control-label Product
              .col-sm-4
                router-link(v-if="section.product" :to="{name: 'product', params: {id: section.product.id}}") {{section.product.name}}
                em.text-muted(v-else) No product

            .row
              label.col-sm-2.control-label First Index
              .col-sm-4
                span {{section.first.codeIndex}}
              label.col-sm-2.control-label First Code
              .col-sm-4(v-if="first && first[0]")
                span.kzcode-default {{ first[0].code }}

            .row
              label.col-sm-2.control-label Last Index
              .col-sm-4
                span {{section.last.codeIndex}}
              label.col-sm-2.control-label Last Code
              .col-sm-4(v-if="last && last[0]")
                span.kzcode-default {{ last[0].code }}

            .row
              label.col-sm-2.control-label Size
              .col-sm-4
                span {{size}}
              label.col-sm-2.control-label Schema
              .col-sm-4
                router-link(v-if="section.metadata" :to="{name: 'viewMetadataSchema', params: {id: section.metadata.schema.id}}") {{section.metadata.schema.name}}
                em.text-muted(v-else) No schema

            .row
              label.col-sm-2.control-label Created
              .col-sm-4
                span {{section.created | date}}

            hr
            .row
              label.col-sm-2.control-label Active Recalls
              .col-sm-10
                PillsList(v-if="recalls" :items="recalls" :clickable="true" @itemClick="goToRecall")
                em.text-muted(v-if="recall.length > 0 && recalls && recalls.length === 0") No active recalls
                em.text-muted(v-if="recallError") {{recallError}}
</template>

<script>
import { dateFilter } from '@/filters/filters'
import PillsList from '@/components/common/PillsList'
import Core from '@/service/apis/Core'
import ErrorEmiter from '@/components/common/ErrorEmiter'

export default {
  extends: ErrorEmiter,
  props: {
    section: {
      required: true
    },
    firstCodeBundle: {
      type: Array,
      required: true
    },
    lastCodeBundle: {
      required: true
    }
  },
  data: () => ({
    recallError: null,
    loading: false,
    recall: []
  }),
  created() {
    this.getRecalls()
  },
  methods: {
    getRecalls() {
      if (this.section) {
        Core.listRecallsInSection(this.$route.params.sectionId)
          .then((resp) => {
            this.recall = resp.data
          })
          .catch((e) => { this.recallError = this.emitError(e) })
      }
    },
    goToRecall(data) {
      this.$router.push(`/trackntrace/configuration/recall/${data.name}`)
    }
  },
  watch: {
    section() {
      this.getRecalls()
    }
  },
  computed: {
    first() {
      return this.firstCodeBundle.length > 0 ? this.firstCodeBundle.filter((c) => c.codeIndex === this.section.first.codeIndex) : []
    },
    last() {
      return this.lastCodeBundle.length > 0 ? this.lastCodeBundle.filter((c) => c.codeIndex === this.section.last.codeIndex) : []
    },
    size() {
      return parseInt(this.section.last.codeIndex - this.section.first.codeIndex, 10) + 1
    },
    recalls() {
      return this.recall.map((r) => ({ name: r }))
    }
  },
  components: {
    PillsList
  },
  filters: {
    date: dateFilter
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/core/order/section/SectionDetails.vue